import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Url, formatTimestamp, security_key } from "../../Services/Api";
import "../Page.css";
import "./style.css";
import CategoryCard from "./priceTagComponents/categoryCards";
import ProductCard from "./priceTagComponents/productCard";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import jsPDF from "jspdf";
import { generatePDF } from "./priceTagsPdf/pdfOption1";
import banner1 from "../../Assets/ptags/banners/1.jpg"
import banner2 from "../../Assets/ptags/banners/4.jpg";
import { IoSettingsOutline } from "react-icons/io5";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import { RxCross1 } from "react-icons/rx";
import SubCategoryCardTabs from "./priceTagComponents/categoryTabs";
import CategoryDropdown from "../../Components/UI-Controls/CategoryDropdown/CategoryDropdown";
import CategoryDropdown2 from "./priceTagComponents/SubCategoryDropdown";
import { FiPlus } from "react-icons/fi";


const AddonSettings = () => {
    const [loading, setLoading] = useState(false);
    const [selectedSettingTab, setSelectedSettingTab] = useState(0);
    const [categories, setCategories] = useState();
    const [subCategories, setSubCategories] = useState({});

    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [subLoading, setSubLoading] = useState(false);


    const handleSubCategoryToggle = (categoryUid, subCategoryUid) => {
        setSelectedSubCategories(prev => {
            const existing = prev.find(item => item.category === categoryUid);
            if (existing) {
                const alreadySelected = existing.subCategories.includes(subCategoryUid);
                const updatedSubs = alreadySelected
                    ? existing.subCategories.filter(uid => uid !== subCategoryUid)
                    : [...existing.subCategories, subCategoryUid];

                return updatedSubs.length > 0
                    ? prev.map(item =>
                        item.category === categoryUid
                            ? { ...item, subCategories: updatedSubs }
                            : item
                    )
                    : prev.filter(item => item.category !== categoryUid); // Remove category if no subs
            } else {
                return [...prev, { category: categoryUid, subCategories: [subCategoryUid] }];
            }
        });
    };



    const fetchMainCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=0`);
            const getAllMainCategories = response.data.categories || [];
            setCategories(getAllMainCategories);
            console.log(getAllMainCategories);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };


    const [allCategories, setAllCategories] = useState([]);

    const fetchAllCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/productCategory/get`);
            const getAllMainCategories = response.data.categories || [];
            setAllCategories(getAllMainCategories);
            console.log(getAllMainCategories);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSubCategories = async (parentId) => {
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=${parentId}`);
            const subs = response.data.categories || [];
            setSubCategories(prev => ({
                ...prev,
                [parentId]: subs
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(`Failed to fetch subcategories for parent ${parentId}:`, error);
        }
    };



    const fetchSelectedCatSub = async () => {
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/ptag/get`, { headers: headers });
            const subs = response.data.data || [];
            setSelectedSubCategories(subs);
            setLoading(false);
        } catch (error) {
            console.error(`Failed to fetch subcategories for parent `, error);
            setLoading(false);
        }
    };

    const fetchSelectedCatSubInd = async () => {
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/ptag/get-sub-cat`, { headers: headers });
            const subs = response.data.data || [];
            setSelectedCategories(subs);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(`Failed to fetch subcategories for parent `, error);
        }
    };


    const setSelectedCateg = async () => {
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        try {
            setLoading(true);
            const response = await axios.post(`${Url}/api/v1/ptag/add`, selectedSubCategories, { headers: headers });
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(`Failed to fetch subcategories for parent `, error);
        }
    };

    const [selectedDetailed, setSelectedDetailed] = useState([]);

    const fetchDetailedSelected = async () => {
        setLoading(true);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        try {
            const response = await axios.get(`${Url}/api/v1/ptag/get-detailed`, { headers: headers });
            const subs = response.data.data || [];
            setSelectedDetailed(subs);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(`Failed to fetch subcategories for parent `, error);
        }
    };



    const setSelectedCategoriesInd = async () => {
        setLoading(true);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        try {
            const response = await axios.post(`${Url}/api/v1/ptag/add-sub-cat`, selectedCategories, { headers: headers });
            fetchAllCategories();
            fetchMainCategories();
            fetchSelectedCatSub();
            fetchDetailedSelected();
            fetchSelectedCatSubInd();
            setLoading(false);
        } catch (error) {
            console.error(`Failed to fetch subcategories for parent `, error);
            setLoading(false);
        }
    };





    useEffect(() => {
        fetchAllCategories();
        fetchMainCategories();
        fetchSelectedCatSub();
        fetchDetailedSelected();
        fetchSelectedCatSubInd();
    }, []);

    useEffect(() => {
        if (categories && categories.length > 0) {
            categories.forEach(cat => {
                fetchSubCategories(cat.uid);
            });
        }
    }, [categories]);



    const deleteDropdown = (index) => {
        const updatedCategories = [...selectedCategories];
        updatedCategories[index] = null;
        setSelectedCategories(updatedCategories);
    };






    const [openIndexInner, setOpenIndexInner] = useState({});


    const toggleAccordionInner = (parentIndex, subIndex) => {
        setOpenIndexInner((prev) => ({
            ...prev,
            [parentIndex]: prev[parentIndex] === subIndex ? null : subIndex
        }));
    };




    const [selectedCategories, setSelectedCategories] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});

    const toggleDropdown = (index, subIndex) => {
        setDropdownOpen((prev) => ({
            ...prev,
            [index]: {
                ...(prev[index] || {}),
                [subIndex]: !prev?.[index]?.[subIndex],
            },
        }));
    };

    const handleSelect = (index, subIndex, category) => {
        setSelectedCategories((prev) => {
            const updated = [...prev];
            const subCat = selectedDetailed[index]?.subCategories?.[subIndex];

            if (!subCat) return updated;

            // Check if subcategory already exists
            const existingIndex = updated.findIndex(
                (item) => item.subcategory === subCat.name
            );

            const newIndividual = {
                category: category.name,
                slug: category.slug,
                inputValue: ""
            };

            if (existingIndex !== -1) {
                const existing = updated[existingIndex];
                const alreadyExists = existing.individuals.some(
                    (c) => c.category === category.name
                );

                if (!alreadyExists) {
                    existing.individuals.push(newIndividual);
                }
            } else {
                updated.push({
                    subcategory: subCat.name,
                    uid: subCat.uid,
                    individuals: [newIndividual]
                });
            }

            return updated;
        });

        setDropdownOpen(index, subIndex)

        console.log(selectedCategories);
    };


    const handleRemove = (index, subIndex, categoryToRemove) => {
        const subCategoryName = selectedDetailed[index]?.subCategories[subIndex]?.name;

        setSelectedCategories((prevSelected) => {
            // Clone previous state to avoid mutation
            const updated = [...prevSelected];

            // Find the subcategory wrapper by name
            const target = updated.find(item => item.subcategory === subCategoryName);
            if (!target) return updated;

            // Filter out the category to remove
            target.individuals = target.individuals.filter(ind => ind.category !== categoryToRemove);

            // Optionally, if individuals becomes empty, you can remove the entire subcategory
            // But depends on your use case — if you want to keep empty subcategories, skip this

            return updated;
        });
    };


    const flattenSelectedCategories = (selectedCategories) => {
        const flatList = [];

        selectedCategories.forEach((categoryGroup) => {
            Object.values(categoryGroup).forEach((entry) => {
                if (entry && entry.subcategory) {
                    flatList.push(entry);
                }
            });
        });

        return flatList;
    };







    return (
        <div className="addon_settings">
            <div className="addon_secting_section">
                <div className="left_side_addons_setting">
                    <div onClick={() => {
                        setSelectedSettingTab(0)
                    }} className={selectedSettingTab === 0 ? "addon_setting_tab active" : "addon_setting_tab"}>
                        Categories
                    </div>
                    <div onClick={() => {
                        setSelectedSettingTab(1)
                    }} className={selectedSettingTab === 1 ? "addon_setting_tab active" : "addon_setting_tab"}>
                        Individuals
                    </div>
                </div>
                <div className="right_side_addons_setting">
                    {selectedSettingTab === 0 && <div className="addons_Settings_1">
                        <h2 className="main_sub_section_heading_add">Price Tag Categories</h2>
                        <button className="updateBtn_addon_setting" onClick={() => {
                            setSelectedCateg()
                        }}>Update</button>
                        {
                            categories && categories.map((item, index) => {
                                const subCats = subCategories[item.uid] || [];
                                return (
                                    <div key={item._id} className="category_Selection_container">
                                        <h3 className="category_heading">{item.name}</h3>
                                        <div className="addons_sub_cat">
                                            {
                                                subCats.map(sub => {
                                                    const isSelected = selectedSubCategories
                                                        .find(cat => cat.category === item.uid)?.subCategories.includes(sub.uid);

                                                    return (
                                                        <SubCategoryCardTabs
                                                            key={sub._id}
                                                            name={sub.name}
                                                            uid={sub.uid}
                                                            slug={sub.slug}
                                                            selected={isSelected}
                                                            onClick={() => handleSubCategoryToggle(item.uid, sub.uid)}
                                                        />
                                                    );
                                                })

                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }


                    </div>}
                    {selectedSettingTab === 1 && <div className="addons_Settings_2">
                        <h2 className="main_sub_section_heading_add">Price Tag Individual Categories</h2>
                        <button className="updateBtn_addon_setting" onClick={() => {
                            setSelectedCategoriesInd()
                        }}>Update</button>
                        <div className="accordian_section_addon">
                            {selectedDetailed &&
                                selectedDetailed.map((item, index) => (
                                    <div key={index} className="sub_section_cat_accordian_1">
                                        {item?.subCategories?.map((itx, subIndex) => (
                                            <div key={subIndex} className="sub_section_cat_accordian">
                                                <div
                                                    className="accordion-header-addon"
                                                    onClick={() => toggleAccordionInner(index, subIndex)}
                                                >
                                                    <span>{itx.name}</span>
                                                    <FiPlus
                                                        className={`accordion-icon ${openIndexInner[index] === subIndex ? 'rotated' : ''}`}
                                                        size={18}
                                                    />
                                                </div>

                                                <div className={`accordion-content-addon ${openIndexInner[index] === subIndex ? 'open' : ''}`}>
                                                    <CategoryDropdown2
                                                        index={index}
                                                        subIndex={subIndex} // ✅ use subIndex from the map
                                                        selectCategoryData={allCategories}
                                                        selectedCategories={selectedCategories}
                                                        toggleDropdown={toggleDropdown}
                                                        dropdownOpen={dropdownOpen}
                                                        handleSelect={handleSelect}
                                                        deleteDropdown={deleteDropdown}
                                                        handleRemove={handleRemove}
                                                        setSelectedCategories={setSelectedCategories}
                                                        subCategoryName={selectedDetailed[index]?.subCategories?.[subIndex]?.name}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}

                        </div>




                    </div>}
                </div>
            </div>
            {loading && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Generating Ptags..."} />
                </div>
            </div>}
        </div>
    )
}

export default AddonSettings;